
// SVG Icon: settings
export default { id: "terriajs-settings" };
export const id = "terriajs-settings";
export const name = "settings";
